import React, { useCallback } from 'react'
import Tilt from 'react-parallax-tilt'
import { NavLink, useHistory } from 'react-router-dom'
import Sparkle from 'react-sparkle'
import styled, { keyframes } from 'styled-components/macro'

import BronzeNFT from '../../assets/bronze-nft.png'
import BronzePenny from '../../assets/Bronze-penny.svg'
import DiamondHands from '../../assets/Diamond-Hands.svg'
import DiamondNFT from '../../assets/diamond-nft.png'
import GoldNFT from '../../assets/gold-nft.png'
import JonahHillSilver from '../../assets/Jonah-hill-silver.svg'
import PlebNFT from '../../assets/pleb-nft.png'
import PlebPepe from '../../assets/Pleb-Pepe.svg'
import SilverNFT from '../../assets/silver-nft.png'
import SmugGold from '../../assets/Smug-Gold.svg'
import {
  USELESS_MULTI_SIG_ADDRESSES,
  USELESS_NFT_ADDRESSES,
  USELESS_ROYALTY_RECEIVER_ADDRESSES,
} from '../../constants/addresses'
import { SupportedChainId } from '../../constants/chains'
import { OPEN_SEA_URL } from '../../constants/misc'

const PageWrapper = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow: hidden;

  a {
    color: ${({ theme }) => theme.text1} !important;
    font-weight: 500 !important;
    text-decoration: none !important;

    :hover {
      color: ${({ theme }) => theme.text2} !important;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 92%;
    padding: 0 4%;
  }
`

const TopSection = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 250px;
  margin-top: 10vh;

  @media screen and (max-width: 450px) {
    margin-top: 0;
  }
`

const TitleWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  display: inline-block;
`

const TitleText = styled.div`
  font-weight: 200;
  font-size: 28px;
  margin-bottom: 10px;

  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
`

const SloganText = styled.div`
  font-weight: 400;
  font-size: 64px;
  margin-bottom: 20px;
  width: 1200px;
  margin-left: -200px;

  @media screen and (max-width: 1100px) {
    max-width: 100%;
    margin-left: 0;
  }

  @media screen and (max-width: 600px) {
    font-size: 42px;
    line-height: 45px;
    margin-bottom: 15px;
  }
`

const carousel = keyframes`
  from {
    transform: translateX(200px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(200px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(400px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(200px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel880 = keyframes`
  from {
    transform: translateX(180px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(180px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(360px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(180px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel780 = keyframes`
  from {
    transform: translateX(150px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(150px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(300px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(150px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel580 = keyframes`
  from {
    transform: translateX(125px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(125px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(250px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(125px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const carousel450 = keyframes`
  from {
    transform: translateX(100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
  8% {
    z-index: 4;
    animation-timing-function: ease-out;
  }
  25% {
    z-index 3;
    transform: translateX(0) scale(0.75);
    animation-timing-function: ease-in;
  }
  50% {
    z-index: 0;
    transform: translateX(100px) scale(0.6);
    animation-timing-function: ease-out;
    box-shadow: 3px 3px 8px 3px rgba(0, 0, 0, 0.5);
  }
  75% {
    z-index: 3;
    transform: translateX(200px) scale(0.75);
    animation-timing-function: ease-in;
    box-shadow: 6px 6px 12px 3px rgba(0, 0, 0, 0.5);
  }
  87% {
    z-index: 4;
    animation-timing-function: ease-in;
  }
  to {
    transform: translateX(100px) scale(1);
    z-index: 5;
    animation-timing-function: ease-out;
    box-shadow: 9px 9px 16px 3px rgba(0, 0, 0, 0.5);
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  text-align: center;
  margin: 100px auto -90px;
  position: relative;
  height: 200px;

  img {
    position: absolute;
    animation-name: ${carousel};
    animation-duration: 20s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    width: 200px;
    height: 200px;
    margin-left: -290px;
    border-radius: 18px;

    :nth-of-type(1) {
      animation-delay: 0s;
    }

    :nth-of-type(2) {
      animation-delay: -4s;
    }

    :nth-of-type(3) {
      animation-delay: -8s;
    }

    :nth-of-type(4) {
      animation-delay: -12s;
    }

    :nth-of-type(5) {
      animation-delay: -16s;
    }
  }

  @media screen and (max-width: 880px) {
    margin: 100px auto -90px;

    img {
      width: 180px;
      height: 180px;
      margin-left: -270px;
      border-radius: 15px;
      animation-name: ${carousel880};
    }
  }

  @media screen and (max-width: 780px) {
    margin: 100px auto -120px;

    img {
      width: 150px;
      height: 150px;
      margin-left: -225px;
      border-radius: 12px;
      animation-name: ${carousel780};
    }
  }

  @media screen and (max-width: 580px) {
    margin: -65px auto -60px;
    transform: translateY(125px);

    img {
      width: 125px;
      height: 125px;
      margin-left: -187px;
      border-radius: 10px;
      animation-name: ${carousel580};
    }
  }

  @media screen and (max-width: 450px) {
    margin: -50px auto -110px;

    img {
      width: 100px;
      height: 100px;
      margin-left: -150px;
      border-radius: 10px;
      animation-name: ${carousel450};
    }
  }
`

const SubtitleText = styled.div`
  font-weight: 200;
  font-size: 17px;
  margin-bottom: 15px;

  @media screen and (max-width: 600px) {
    font-size: 15px;
  }
`

const BulletsSection = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
`

const Bullet = styled.div`
  width: calc(100% - 80px);
  margin-bottom: 100px;
  padding: 0 40px;

  @media screen and (max-width: 500px) {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
`

const BulletTitle = styled.div`
  width: 25%;
  margin-right: 5%;
  font-size: 42px;
  font-weight: 400;
  display: inline-block;
  vertical-align: top;

  @media screen and (max-width: 1000px) {
    font-size: 38px;
    width: 30%;
  }

  @media screen and (max-width: 800px) {
    width: 50%;
    font-size: 40px;
    margin-bottom: 12px;
  }

  @media screen and (max-width: 600px) {
    width: 70%;
  }
`

const BulletText = styled.div`
  width: 70%;
  font-size: 18px;
  font-weight: 300;
  display: inline-block;
  vertical-align: top;
  line-height: 26px;

  @media screen and (max-width: 1000px) {
    line-height: 28px;
    width: 65%;
  }

  @media screen and (max-width: 800px) {
    width: 100%;
    font-size: 17px;
    line-height: 25px;
  }
`

const FunctionSection = styled.div`
  width: 100%;
  margin-top: 200px;
`

const FunctionSectionWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`

/*const FunctionSectionTitle = styled.div`
  width: 100%;
  max-width: 1200px;
  text-align: center;
  font-size: 32px;
  font-weight: 400;
  margin-bottom: 50px;
`

const Function = styled.div`
  width: 350px;
  margin: 10px 25px;
  display: inline-block;
  vertical-align: top;
  background: #060606;
  border-radius: 8px;
  padding: 30px 40px;
  box-shadow: 2px 3px 14px 4px rgb(0 0 0 / 50%), 2px 3px 9px -6px rgb(0 0 0 / 50%);
`

const FunctionTitle = styled.div`
  font-size: 24px;
  font-weight: 200;
  margin-bottom: 20px;
`

const FunctionContent = styled.div`
  font-size: 16px;
  font-weight: 400;
`*/

const FunctionSectionTitle = styled.div`
  width: 100%;
  max-width: 1200px;
  text-align: center;
  font-size: 42px;
  font-weight: 400;
  margin-bottom: 50px;
`

const Function = styled.div`
  width: 48%;
  margin-bottom: 50px;
`

const FunctionTitle = styled.div`
  font-size: 60px;
  font-weight: 400;
  margin-bottom: 20px;

  @media screen and (max-width: 1200px) {
    font-size: 54px;
    margin-bottom: 16px;
  }
`

const FunctionContent = styled.div`
  font-size: 24px;
  font-weight: 200;

  @media screen and (max-width: 1200px) {
    font-size: 20px;
  }
`

const TiersRightLeft = styled.div`
  @media screen and (max-width: 1000px) {
    width: 320px;
    display: inline-block;
    margin: 0 auto 20px;
  }
`

const TiersRightRight = styled.div`
  @media screen and (max-width: 1000px) {
    width: 350px;
    display: inline-block;
    padding-top: 50px;
  }

  @media screen and (max-width: 880px) {
    display: none;
  }
`

const SixtyNineLol = styled.span`
  font-weight: 300;
`

const BuyButton = styled.div`
  border: 3px solid white;
  background: none;
  border-radius: 10px;
  padding: 10px 20px;
  font-weight: 400;
  font-size: 20px;
  width: fit-content;
  cursor: pointer;
  color: white;
  text-decoration: none !important;
  margin-top: 24px;

  a {
    text-decoration: none !important;
  }

  :hover {
    background: white;
    color: #24232a;
    text-decoration: none !important;
  }

  @media screen and (max-width: 880px) {
    font-size: 18px;
  }

  @media screen and (max-width: 600px) {
    font-size: 16px;
  }

  @media screen and (max-width: 450px) {
    font-size: 15px;
  }
`

const Total = styled.div`
  width: fit-content;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid white;
  font-weight: 400;
`

const TiersSection = styled.div`
  width: 100%;

  > div > span {
    z-index: 9999;
  }

  .glare-wrapper {
    border-radius: 10px !important;
  }

  @media screen and (max-width: 800px) {
    > div {
      margin: 7px !important;
    }
  }

  @media screen and (max-width: 550px) {
    > div {
      width: 100% !important;
      margin: 8px 0 !important;
    }
  }
`

const TiersWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`

const TiersTitle = styled.div`
  font-size: 36px;
  font-weight: 400;
`

const Tier = styled.div<{ isDiamond?: boolean }>`
  padding: 20px;
  border-radius: 10px;
  padding: 30px;
  width: 240px;
  display: inline-block;
  height: 185px;
  text-align: left;
  box-shadow: 2px 3px 14px 4px rgb(0 0 0 / 50%), 2px 3px 9px -6px rgb(0 0 0 / 50%);
  overflow: hidden;
  margin-bottom: -4px;

  ${({ isDiamond }) =>
    isDiamond &&
    `
    background: linear-gradient(315deg, rgba(214,214,214,1) 0%, rgba(224,224,224,1) 16%, rgba(214,214,214,1) 30%, rgba(252,252,252,1) 68%, rgba(229,228,226,1) 100%);
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(272,956,490)'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23E5E4E2'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.03'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
    background-size: cover;
    color: black;
    position: relative;
    width: 560px;
    height: 200px;
  `} @media screen and(max-width: 1200 px) {
    width: 210px;
    height: 155px;
    padding: 20px;

    ${({ isDiamond }) =>
      isDiamond &&
      `
        width: 480px;
        height: 155px;
      `}
  }
  ${({ isDiamond }) =>
    isDiamond &&
    `
      @media screen and (max-width: 800px) {
        width: 474px;
      }
    `} @media screen and(max-width: 600 px) {
    width: 190px;
    height: 145px;

    ${({ isDiamond }) =>
      isDiamond &&
      `
        width: 434px;
        height: 150px;
      `}
  }

  @media screen and (max-width: 550px) {
    width: calc(100% - 40px);
    min-height: 70px;
    height: auto;
  }
`

const TierLeft = styled.div`
  width: 80px;
  height: 80px;
  display: inline-block;
  vertical-align: top;
  margin: 0 auto;
  display: block;

  @media screen and (max-width: 1200px) {
    width: 55px;
    height: 55px;
  }

  @media screen and (max-width: 550px) {
    width: 25%;
    display: inline-block;
    vertical-align: top;
  }
`

const TierImage = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  img {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
`

const DiamondTierImage = styled(TierImage)`
  width: 300%;
  height: 300%;
  margin-left: -100%;
  transform: translateY(-38%);

  @media screen and (max-width: 550px) {
    transform: translateY(-20%);
    margin-left: -106%;
  }
`

const GoldTierImage = styled(TierImage)`
  width: 280%;
  height: 280%;
  margin-left: -100%;
  transform: translateY(-32%);

  @media screen and (max-width: 550px) {
    transform: translateY(-28%);
    margin-left: -100%;
  }
`

const SilverTierImage = styled(TierImage)`
  width: 270%;
  height: 270%;
  margin-left: -75%;
  transform: translateY(-32%);

  @media screen and (max-width: 550px) {
    transform: translateY(-28%);
    margin-left: -86%;
  }
`

const BronzeTierImage = styled(TierImage)`
  width: 300%;
  height: 300%;
  margin-left: -100%;
  transform: translateY(-32%);

  @media screen and (max-width: 550px) {
    transform: translateY(-28%);
    margin-left: -108%;
  }
`

const PlebTierImage = styled(TierImage)`
  width: 360%;
  height: 360%;
  margin-left: -150%;
  transform: translateY(-30%);

  @media screen and (max-width: 550px) {
    transform: translateY(-26%);
    margin-left: -142%;
  }
`

const TierRight = styled.div`
  width: calc(100% - 100px);
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
  width: 100%;
  margin-left: 0;

  @media screen and (max-width: 550px) {
    width: 75%;
    display: inline-block;
    vertical-align: top;
  }

  @media screen and (max-width: 450px) {
    width: 72%;
    margin-left: 3%;
  }
`

const TierTitle = styled.div`
  width: 100%;
  text-align: left;
  font-size: 26px;
  text-align: center;
  font-size: 29px;
  margin: 10px 0;

  @media screen and (max-width: 1200px) {
    font-size: 27px;
    margin: 8px 0 5px 0;
  }

  @media screen and (max-width: 1000px) {
    margin: 8px 0 2px 0;
  }

  @media screen and (max-width: 600px) {
    font-size: 25px;
  }

  @media screen and (max-width: 600px) {
    text-align: left;
    margin-bottom: 4px;
    margin-top: 0;
  }
`

const TierDescription = styled.div<{ isDiamond?: boolean }>`
  width: 100%;
  font-size: 15px;
  font-weight: 300;
  ${({ isDiamond }) => isDiamond && 'margin-left: 40px;'} @media screen and(max-width: 1200 px) {
    font-size: 13px;
    ${({ isDiamond }) => isDiamond && 'margin-left: 20px;'}
  }

  @media screen and (max-width: 1200px) {
    font-size: 12px;
    ${({ isDiamond }) => isDiamond && 'margin-left: 10px;'}
  }

  @media screen and (max-width: 550px) {
    margin-left: 0px;
  }
`

const Tiers = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  ${FunctionContent} {
    font-size: 28px;
    font-weight: 300;

    @media screen and (max-width: 1200px) {
      font-size: 24px;
    }
  }

  @media screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column-reverse;
  }
`

const TiersLeft = styled.div`
  width: 60%;
  display: inline-block;
  vertical-align: top;
  text-align: center;

  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`

const TiersRight = styled.div`
  width: calc(40% - 25px);
  display: inline-block;
  vertical-align: top;
  padding-left: 25px;

  @media screen and (max-width: 1000px) {
    width: 790px;
    padding-left: 0;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }

  @media screen and (max-width: 880px) {
    flex-direction: column;
    width: 100%;
  }
`

const BottomTiersLink = styled.div`
  display: none;

  @media screen and (max-width: 880px) {
    display: block;
    width: 100%;
    text-align: center;
    margin-top: -25px;

    > div {
      display: inline-block;

      > div:nth-of-type(1) {
        margin-left: 8px;
      }
    }
  }
`

const RealNFTImages = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 100%;

  img {
    width: 100px;
    margin-left: -24px;
    margin-top: 30px;
    box-shadow: 3px 3px 10px 3px rgb(0 0 0 / 50%);
    border-radius: 8px;

    :nth-of-type(1) {
      transform: rotate(-30deg) translate(13px, 45px);
    }

    :nth-of-type(2) {
      transform: rotate(-15deg) translate(11px, 12px);
    }

    :nth-of-type(3) {
      transform: translateY(0px);
    }

    :nth-of-type(4) {
      transform: rotate(15deg) translate(-11px, 12px);
    }

    :nth-of-type(5) {
      transform: rotate(30deg) translate(-13px, 45px);
    }

    @media screen and (max-width: 1200px) {
      width: 85px;
      margin-left: -24px;
      margin-top: 30px;
      box-shadow: 3px 3px 10px 3px rgb(0 0 0 / 50%);
      border-radius: 8px;

      :nth-of-type(1) {
        transform: rotate(-30deg) translate(11px, 36px);
      }

      :nth-of-type(2) {
        transform: rotate(-15deg) translate(10px, 10px);
      }

      :nth-of-type(3) {
        transform: translateY(0px);
      }

      :nth-of-type(4) {
        transform: rotate(15deg) translate(-10px, 10px);
      }

      :nth-of-type(5) {
        transform: rotate(30deg) translate(-11px, 36px);
      }
    }
  }

  @media screen and (max-width: 880px) {
    margin-left: 25px;
  }
`

const MintPageLink = styled.div`
  width: 100%;
  margin-top: 40px;

  @media screen and (max-width: 880px) {
    margin-left: 25px;
  }
`

const MintPageLinkButton = styled.div`
  border: 3px solid white;
  border-radius: 8px;
  font-weight: 500;
  font-size: 20px;
  background: none;
  text-decoration: none;
  cursor: pointer;
  padding: 10px 20px;
  width: fit-content;
  margin-left: 110px;

  :hover {
    background: white;
    color: #232329;
  }

  @media screen and (max-width: 1200px) {
    margin-left: 80px;
  }
`

const Left = styled.div`
  width: 40%;
  padding: 5%;
  display: inline-block;
  vertical-align: top;
  margin-top: 100px;

  ${Function} {
    width: 100%;
  }

  ${FunctionTitle} {
    font-size: 34px;
    margin-bottom: 15px;

    @media screen and (max-width: 600px) {
      font-size: 28px;
    }
  }

  ${FunctionContent} {
    font-size: 18px;
    line-height: 27px;

    @media screen and (max-width: 600px) {
      font-size: 15px;
      line-height: 24px;
    }
  }

  @media screen and (max-width: 880px) {
    width: calc(100% - 80px);
    padding: 0 40px;
    margin-top: 180px;
    margin-bottom: 0;
  }

  @media screen and (max-width: 500px) {
    width: calc(100% - 40px);
    padding: 0 20px;
    margin-top: 200px;
  }
`

const Right = styled(Left)`
  @media screen and (max-width: 880px) {
    margin-top: 0;
    margin-bottom: 50px;
  }
`

const SaleWrapper = styled.div`
  width: calc(100% - 80px);
  max-width: 1200px;
  margin: 150px auto;
  padding: 0 40px;

  @media screen and (max-width: 880px) {
    display: flex;
    flex-direction: column-reverse;
  }

  @media screen and (max-width: 500px) {
    width: calc(100% - 40px);
    padding: 0 20px;
  }
`

const SaleText = styled.div`
  width: calc(60% - 40px);
  display: inline-block;
  vertical-align: top;
  padding-right: 40px;

  div,
  a {
    text-decoration: none !important;
  }

  @media screen and (max-width: 880px) {
    width: 100%;
    padding: 0;
  }
`

const MintingTitle = styled(FunctionTitle)`
  margin-bottom: 10px;

  @media screen and (max-width: 600px) {
    font-size: 42px;
  }
`

const MintingContent = styled(FunctionContent)`
  font-size: 20px;
  line-height: 28px;

  @media screen and (max-width: 1200px) {
    font-size: 18px;
    line-height: 26px;
  }

  @media screen and (max-width: 600px) {
    font-size: 16px;
    line-height: 23.5px;
  }

  @media screen and (max-width: 450px) {
    font-size: 15px;
    line-height: 22px;
  }
`

const SaleImage = styled.div`
  width: 40%;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  position: relative;

  > div > div:nth-of-type(2) {
    border-radius: 25px !important;
  }

  .glare-wrapper {
    border-radius: 18px !important;
  }

  img {
    width: 300px;
    height: 300px;
    margin-bottom: -4px;
  }

  > img {
    width: 240px;
    height: 240px;
    position: absolute;
    transform: rotate(24deg);
    right: -5px;
    top: 24px;
    margin-bottom: 0;
  }

  @media screen and (max-width: 1200px) {
    margin-top: 10px;
  }

  @media screen and (max-width: 1100px) {
    margin-top: 20px;
  }

  @media screen and (max-width: 1000px) {
    margin-top: 30px;
  }

  @media screen and (max-width: 900px) {
    margin-top: 40px;
  }

  @media screen and (max-width: 880px) {
    display: none;
  }
`

const SaleImageMobile = styled.div`
  width: 100%;
  display: none;

  @media screen and (max-width: 880px) {
    display: inline-block;
  }
`

const NFTsImageWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  height: 200px;
  margin-bottom: 30px;
  margin-top: -30px;

  @media screen and (max-width: 600px) {
    margin-bottom: 0px;
    height: 185px;
  }

  @media screen and (max-width: 450px) {
    height: 150px;
  }
`

const NFTsImageInner = styled.div`
  width: 180px;
  height: 180px;
  display: inline-block;
  position: relative;

  img {
    /*width: 250px;
    height: 250px;*/
    width: 180px;
    height: 180px;
    position: absolute;
    left: 0;
    top: 0;

    :nth-of-type(1) {
      z-index: 5;
    }

    :nth-of-type(2) {
      z-index: 4;
      transform: rotate(-16deg);
      /*height: 215px;
      width: 215px;*/
      height: 150px;
      width: 150px;
      top: 20px;
      left: -70px;
    }

    :nth-of-type(3) {
      z-index: 3;
      transform: rotate(16deg);
      /*height: 215px;
      width: 215px;*/
      height: 150px;
      width: 150px;
      top: 20px;
      left: 100px;
    }

    :nth-of-type(4) {
      z-index: 2;
      transform: rotate(-32deg);
      /*height: 180px;
      width: 180px;*/
      height: 120px;
      width: 120px;
      top: 60px;
      left: -120px;
    }

    :nth-of-type(5) {
      z-index: 1;
      transform: rotate(32deg);
      /*height: 180px;
      width: 180px;*/
      height: 120px;
      width: 120px;
      top: 60px;
      left: 180px;
    }
  }

  @media screen and (max-width: 600px) {
    width: 150px;
    height: 150px;

    img {
      width: 150px;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;

      :nth-of-type(1) {
        z-index: 5;
      }

      :nth-of-type(2) {
        z-index: 4;
        transform: rotate(-16deg);
        height: 125px;
        width: 125px;
        top: 18px;
        left: -60px;
      }

      :nth-of-type(3) {
        z-index: 3;
        transform: rotate(16deg);
        height: 125px;
        width: 125px;
        top: 18px;
        left: 84px;
      }

      :nth-of-type(4) {
        z-index: 2;
        transform: rotate(-32deg);
        height: 100px;
        width: 100px;
        top: 50px;
        left: -102px;
      }

      :nth-of-type(5) {
        z-index: 1;
        transform: rotate(32deg);
        height: 100px;
        width: 100px;
        top: 50px;
        left: 150px;
      }
    }
  }

  @media screen and (max-width: 450px) {
    width: 120px;
    height: 120px;

    img {
      width: 120px;
      height: 120px;
      position: absolute;
      left: 0;
      top: 0;

      :nth-of-type(1) {
        z-index: 5;
      }

      :nth-of-type(2) {
        z-index: 4;
        transform: rotate(-16deg);
        height: 100px;
        width: 100px;
        top: 15px;
        left: -48px;
      }

      :nth-of-type(3) {
        z-index: 3;
        transform: rotate(16deg);
        height: 100px;
        width: 100px;
        top: 15px;
        left: 67px;
      }

      :nth-of-type(4) {
        z-index: 2;
        transform: rotate(-32deg);
        height: 80px;
        width: 80px;
        top: 40px;
        left: -80px;
      }

      :nth-of-type(5) {
        z-index: 1;
        transform: rotate(32deg);
        height: 80px;
        width: 80px;
        top: 40px;
        left: 120px;
      }
    }
  }
`

const CardOuter = styled.div`
  display: inline-block;
  border-radius: 25px;
  width: 250px;
  height: 250px;
  padding-bottom: 60%;
  background-color: #a2a2a2;
  background-image: url('https://www.transparenttextures.com/patterns/brushed-alum.png');
  /* This is mostly intended for prototyping; please download the pattern and re-host for production environments. Thank you! */
  padding: 5%;
`

const CardOuterGold = styled(CardOuter)`
  position: absolute;
  transform: rotate(32deg);
  z-index: 0;
  width: 175px;
  height: 175px;
  right: 10px;
  top: 40px;
  padding: 2.5%;
  background-color: #b69119;
  background-image: url('https://www.transparenttextures.com/patterns/brushed-alum.png');
  /* This is mostly intended for prototyping; please download the pattern and re-host for production environments. Thank you! */

  > div {
    background: linear-gradient(to bottom, #d4af37 0%, #c5a028 100%);
  }
`

const CardInner = styled.div`
  background: #c0c0c0;
  border-radius: 20px;
  width: 70%;
  height: 70%;
  padding: 15%;
  background-color: #c0c0c0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(272,956,490)'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23E5E4E2'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='540' height='450' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.03'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  /* This is mostly intended for prototyping; please download the pattern and re-host for production environments. Thank you! */

  img {
    height: 100%;
    width: auto;
  }
`

const FAQWrapper = styled.div`
  width: calc(100% - 80px);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;

  @media screen and (max-width: 500px) {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
`

const FAQTitle = styled.div`
  width: 100%;
  text-align: center;
  font-size: 60px;
  margin-bottom: 20px;
`

const FAQInner = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`

const FAQ = styled.div`
  width: 300px;
  text-align: left;
  display: inline-block;
  vertical-align: top;
  margin: 10px;
  margin-bottom: 35px;

  @media screen and (max-width: 1100px) {
    width: calc(50% - 20px);
    max-width: 400px;
  }

  @media screen and (max-width: 650px) {
    width: 100%;
  }
`

const Question = styled.div`
  width: 100%;
  font-size: 18px;
  margin-bottom: 10px;
`

const Answer = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 200;
  line-height: 1.4rem;
`

// TODO - make sure to completely wipe light theme from the site so it doesn't end up on it when the page loads
export default function Home() {
  const history = useHistory()
  const handleBuyLink = useCallback(() => history.push('/buy'), [history])

  return (
    <PageWrapper>
      <TopSection>
        <TitleWrapper>
          <TitleText>Useless NFT</TitleText>
          <SloganText>The first 100% honest NFT project.</SloganText>
          <SubtitleText>
            You&apos;re already throwing ETH at random NFTs you heard about on Twitter or Discord or TikTok or from that
            one friend, so you might as well buy this one. We&apos;ll take that ETH and buy stuff with it. Probably a
            bigger TV.
          </SubtitleText>
          <SubtitleText>Seriously, don&apos;t buy these NFTs.</SubtitleText>
        </TitleWrapper>
        <ImageWrapper>
          <img src={DiamondNFT} />
          <img src={GoldNFT} />
          <img src={SilverNFT} />
          <img src={BronzeNFT} />
          <img src={PlebNFT} />
        </ImageWrapper>
      </TopSection>
      <BulletsSection>
        <Bullet>
          <BulletTitle>First of its kind NFT sale</BulletTitle>
          <BulletText>
            NFTs are overplayed. Any of them that were ever cool now cost more than a house, and the rest are copycats
            being pushed by influencers trying to convince you they&apos;re worth something. Then after the price has
            been pumped and the creators and influencers make their exit, the NFTs lose almost all their
            &ldquo;value.&rdquo; &ldquo;Investors&rdquo; buy in thinking they&apos;re getting the newest Bored Ape but
            end up stuck holding an illiquid JPEG so they claim to be &ldquo;in it for the art.&rdquo; This project is
            different. Useless NFT is up front about having no use or value.
            {/*`NFTs are overplayed. Any of them that were ever cool now cost more than a house, and the rest are
            copycats being pushed by influencers trying to convince you they're worth something. Then after the price
            has been pumped and the creators and influencers make their exit, the NFTs lose almost all their "value".
            "Investors" buy in thinking they're getting the newest Bored Ape and end up with a crappy picture
            worth less than the electrons it's printed on. This one is different. Useless NFT is very up front about having no
            use or value.`*/}
          </BulletText>
        </Bullet>
        <Bullet>
          <BulletTitle>Uniquely non-unique</BulletTitle>
          <BulletText>
            No, each NFT will not have its own funny hat. No one will buy your exact NFT for having sunglasses. It will
            not give you that warm feeling of knowing no one else has the same exact digital image. Every tier of NFT is
            a middle finger, and the NFT you own will look exactly like every other NFT in your tier. Except we took it
            a step further, just to show how little the image or attributes matter. Useless NFT has a built-in system to
            let others change your NFT&apos;s image and attributes. That&apos;s how not special this NFT is. Just like
            every other NFT tries to pretend not to be.
          </BulletText>
        </Bullet>
        <Bullet>
          <BulletTitle>Guaranteed Value</BulletTitle>
          <BulletText>
            These NFTs have guaranteed present and future value - no value at all! And we have no expectation that they
            ever will. They will not be going to the moon, they will not be changing the way art is traded, the IP
            won&apos;t be acquired by Yuga Labs, and they will not help you pick up chicks at the bar. They&apos;re
            called Useless NFTs for a reason.
          </BulletText>
        </Bullet>
      </BulletsSection>
      <FunctionSection>
        <FunctionSectionWrapper>
          {/*<FunctionSectionTitle>How Useless NFT works</FunctionSectionTitle>*/}
          <Tiers>
            <TiersLeft>
              <TiersSection>
                <Tilt
                  tiltReverse={true}
                  tiltMaxAngleX={8}
                  tiltMaxAngleY={8}
                  glareEnable={false}
                  style={{
                    width: 'fit-content',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    borderRadius: '10px',
                    margin: '10px',
                  }}
                >
                  <Tier style={{ background: 'white', color: 'black' }}>
                    <TierLeft>
                      <PlebTierImage>
                        <img src={PlebPepe} />
                      </PlebTierImage>
                    </TierLeft>
                    <TierRight>
                      <TierTitle>Pleb</TierTitle>
                      <TierDescription>
                        Wow congrats, you got the most useless of all the Useless NFTs. A true testament to wasted ETH.
                      </TierDescription>
                    </TierRight>
                  </Tier>
                </Tilt>
                <Tilt
                  tiltReverse={true}
                  tiltMaxAngleX={8}
                  tiltMaxAngleY={8}
                  glareEnable={true}
                  style={{
                    width: 'fit-content',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    borderRadius: '10px',
                    margin: '10px',
                  }}
                >
                  <Tier style={{ background: '#b8860b', color: 'black' }}>
                    <TierLeft>
                      <BronzeTierImage>
                        <img src={BronzePenny} />
                      </BronzeTierImage>
                    </TierLeft>
                    <TierRight>
                      <TierTitle>Bronze</TierTitle>
                      <TierDescription>{`- At least it's not pleb tier`}</TierDescription>
                    </TierRight>
                  </Tier>
                </Tilt>
                <Tilt
                  tiltReverse={true}
                  tiltMaxAngleX={8}
                  tiltMaxAngleY={8}
                  glareEnable={true}
                  style={{
                    width: 'fit-content',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    borderRadius: '10px',
                    margin: '10px',
                  }}
                >
                  <Tier style={{ background: 'linear-gradient(to bottom, #C0C0C0 0%, #B1B1B1 100%)', color: 'black' }}>
                    <TierLeft>
                      <SilverTierImage>
                        <img src={JonahHillSilver} />
                      </SilverTierImage>
                    </TierLeft>
                    <TierRight>
                      <TierTitle>Silver</TierTitle>
                      <TierDescription>{`- Bronze but shinier`}</TierDescription>
                    </TierRight>
                  </Tier>
                </Tilt>
                <Tilt
                  tiltReverse={true}
                  tiltMaxAngleX={8}
                  tiltMaxAngleY={8}
                  glareEnable={true}
                  style={{
                    width: 'fit-content',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    borderRadius: '10px',
                    margin: '10px',
                  }}
                >
                  <Tier
                    style={{
                      background: 'linear-gradient(to bottom, #D4AF37 0%, #C5A028 100%)',
                      color: 'black',
                    }}
                  >
                    <TierLeft>
                      <GoldTierImage>
                        <img src={SmugGold} />
                      </GoldTierImage>
                    </TierLeft>
                    <TierRight>
                      <TierTitle>Gold</TierTitle>
                      <TierDescription>
                        {`- Comes with a false sense of superiority`}
                        <br />
                        {`- Can vote in the Useless Council`}
                      </TierDescription>
                    </TierRight>
                  </Tier>
                </Tilt>
                <Tilt
                  tiltReverse={true}
                  tiltMaxAngleX={8}
                  tiltMaxAngleY={3}
                  glareEnable={true}
                  style={{
                    width: 'auto',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    borderRadius: '10px',
                    margin: '10px',
                  }}
                >
                  <Sparkle />
                  <Tier isDiamond={true}>
                    <TierLeft>
                      <DiamondTierImage>
                        <img src={DiamondHands} />
                      </DiamondTierImage>
                    </TierLeft>
                    <TierRight>
                      <TierTitle>Extra Special Super Rare Diamond</TierTitle>
                      <TierDescription isDiamond={true}>
                        {`- The only actually unique NFT`}
                        <br />
                        {`- Can vote in the Useless Council`}
                        <br />
                        {`- Will receive half of all trading royalties (the rest are split with the Useless Council)`}
                      </TierDescription>
                    </TierRight>
                  </Tier>
                </Tilt>
              </TiersSection>
            </TiersLeft>
            <TiersRight>
              <TiersRightLeft>
                <FunctionTitle>Tiers</FunctionTitle>
                <FunctionContent>
                  8,889 pleb tier NFTs
                  <br />
                  1,000 <span style={{ color: '#b8860b', fontWeight: 400 }}>bronze</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;100 <span style={{ color: '#C0C0C0', fontWeight: 400 }}>silver</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10 <span style={{ color: '#FFD700', fontWeight: 400 }}>gold</span>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1{' '}
                  <div
                    style={{
                      display: 'inline-block',
                      verticalAlign: 'top',
                      position: 'relative',
                      color: '#E5E4E2',
                      fontWeight: 400,
                    }}
                  >
                    <Sparkle />
                    extra special
                    <br />
                    super rare diamond
                  </div>{' '}
                  <Total>10,000 Total Useless NFTs</Total>
                </FunctionContent>
              </TiersRightLeft>
              <TiersRightRight>
                <RealNFTImages>
                  <img src={PlebNFT} />
                  <img src={BronzeNFT} />
                  <img src={SilverNFT} />
                  <img src={GoldNFT} />
                  <img src={DiamondNFT} />
                </RealNFTImages>
                <MintPageLink>
                  <MintPageLinkButton onClick={handleBuyLink}>Mint NFT</MintPageLinkButton>
                </MintPageLink>
              </TiersRightRight>
            </TiersRight>
          </Tiers>
          <BottomTiersLink>
            <TiersRightRight>
              <RealNFTImages>
                <img src={PlebNFT} />
                <img src={BronzeNFT} />
                <img src={SilverNFT} />
                <img src={GoldNFT} />
                <img src={DiamondNFT} />
              </RealNFTImages>
              <MintPageLink>
                <MintPageLinkButton onClick={handleBuyLink}>Mint NFT</MintPageLinkButton>
              </MintPageLink>
            </TiersRightRight>
          </BottomTiersLink>
          <Left>
            <Function>
              <FunctionTitle>Image & attribute changing power</FunctionTitle>
              <FunctionContent>
                Any NFT holder can change the NFT image and attributes for every NFT holder in the tiers below them.
                Bronze can change it for plebs, Silver can change it for Bronze and plebs, Gold for all below them, and
                Diamond at the top has the power to change the NFT image and attribute for every NFT holder. That&apos;s
                how pointless these Useless NFTs are. For all we know, in a few weeks you may own an NFT that&apos;s
                just an advertisement for another NFT project. Wouldn&apos;t that have been ETH well spent?
              </FunctionContent>
            </Function>
          </Left>
          <Right>
            <Function>
              <FunctionTitle>The Useless Council</FunctionTitle>
              <FunctionContent>
                Gold and Diamond tier Useless NFT holders get a way to feel extra special - by being able to vote on the
                Useless Council. The Useless Council is an 11-user multi-sig wallet that manages Useless NFT. The
                Useless Council will own the ENS domains that host the website, receive 50% of the royalty fees
                generated on{' '}
                <a href={OPEN_SEA_URL} target={'_blank'} rel="noreferrer">
                  OpenSea
                </a>
                , and have the option to change the tax rate for image/attribute changing. That&apos;s right, once this
                thing is built and live, we&apos;re done with it. There is no dedicated team of developers and artists.
                We&apos;re handing it all off to a group of people that made the questionable decision to purchase
                Useless NFT(s) and then got lucky enough to get a shinier one than you.
              </FunctionContent>
            </Function>
          </Right>
          <SaleWrapper>
            <SaleText>
              <MintingTitle>Minting</MintingTitle>
              <MintingContent>
                For 0.05<SixtyNineLol>69</SixtyNineLol> ETH, you can get your very own Useless NFT. You won&apos;t know
                which one you got until the sale ends. Maybe you&apos;ll get lucky and get a gold one, or even diamond.
                Or maybe you&apos;ll get really lucky and come to your senses before even buying a Useless NFT. If the
                sale never ends and all 10,000 are never minted, (which, let&apos;s be honest, we&apos;re not expecting
                it to), you&apos;ll never know how rare your Useless NFT is.
              </MintingContent>
              <BuyButton onClick={handleBuyLink}>Get Your Useless NFT</BuyButton>
            </SaleText>
            <SaleImage>
              <img src={GoldNFT} />
              <Tilt
                tiltReverse={true}
                tiltMaxAngleX={15}
                tiltMaxAngleY={15}
                glareEnable={true}
                style={{ width: 'fit-content', margin: '0 auto', borderRadius: '25px' }}
              >
                <Sparkle />
                <img src={DiamondNFT} />
              </Tilt>
            </SaleImage>
            <SaleImageMobile>
              <NFTsImageWrapper>
                <NFTsImageInner>
                  <img src={DiamondNFT} />
                  <img src={GoldNFT} />
                  <img src={SilverNFT} />
                  <img src={BronzeNFT} />
                  <img src={PlebNFT} />
                </NFTsImageInner>
              </NFTsImageWrapper>
            </SaleImageMobile>
          </SaleWrapper>
        </FunctionSectionWrapper>
      </FunctionSection>
      <FAQWrapper>
        <FAQTitle>FAQ</FAQTitle>
        <FAQInner>
          <FAQ>
            <Question>Is this a joke or a scam?</Question>
            <Answer>
              Nope! You will really receive an NFT that will have all the promised value and benefits - namely that it
              will be worthless and useless. You&apos;re literally giving your ETH to someone on the internet in
              exchange for a useless NFT. But hey, is that really so different than the rest of the NFT market? The
              smart contracts are published and transparent, but other than that there is no whitepaper, or dedicated
              team, or secret club you get to go to, or some charity being funded that will be saving the world.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>Why are you doing this?</Question>
            <Answer>
              Because we&apos;re a few developers with too much time on our hands who felt that it was time there was an
              NFT that wasn&apos;t pretentiously pretending to be something more than what it is. Also we were fans of
              Useless Ethereum Token.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>Isn&apos;t this just a ripoff of Useless Ethereum Token?</Question>
            <Answer>
              Yes. Yes it is. But this is an NFT series. And hey, UET sold a lot, so why not? And anyway 95% of NFTs on
              the market are a ripoff of Crypto Punks or Bored Apes. At least we&apos;re honest about it.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>What can I do with my Useless NFT?</Question>
            <Answer>
              Seriously? It&apos;s an NFT. You can hold it, look at it, or transfer it. We really doubt you&apos;ll be
              able to sell it, so probably just hold it. Maybe you could use it as a profile picture or something if you
              really want to show the world how you choose to spend your ETH. If you got a particularly shiny Useless
              NFT, you&apos;ll be able to change the image & attributes for everyone with a Useless NFT less than yours,
              so we guess that&apos;s a plus.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>What will the team be developing with the proceeds from the sale?</Question>
            <Answer>
              We&apos;ll be developing our tans in the Bahamas if enough people make the questionable decision to buy
              this.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>Will there ever be another chance to buy Useless NFTs after the minting ends?</Question>
            <Answer>
              No, we&apos;ve wasted more than enough time on this, and we can&apos;t see why the world needs any more
              Useless NFT sales. Once they&apos;re minted they&apos;re gone, go buy one from someone else on{' '}
              <a href={OPEN_SEA_URL} target={'_blank'} rel="noreferrer">
                OpenSea
              </a>{' '}
              and pay royalties to the Useless Council. They probably need the ETH if they wasted theirs on the mint
              mint anyway.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>Were the contracts audited? How can I trust it?</Question>
            <Answer>
              Reality is you shouldn&apos;t trust this mint any more than the one your friend just told you &ldquo;was
              legit.&rdquo; Just like the mint you bought into last week, these contracts aren&apos;t audited, but we
              have &gt;99% line & branch test coverage for each of the published smart contracts. You can click each
              contract&apos;s name to view them on Etherscan:
              <ul>
                <li>
                  <a
                    target={'_blank'}
                    href={`https://etherscan.io/token/${USELESS_NFT_ADDRESSES[SupportedChainId.MAINNET]}`}
                    rel="noreferrer"
                  >
                    Useless NFT
                  </a>
                </li>
                <li>
                  <a
                    target={'_blank'}
                    href={`https://etherscan.io/address/${USELESS_MULTI_SIG_ADDRESSES[SupportedChainId.MAINNET]}`}
                    rel="noreferrer"
                  >
                    Useless Council
                  </a>
                </li>
                <li>
                  <a
                    target={'_blank'}
                    href={`https://etherscan.io/address/${
                      USELESS_ROYALTY_RECEIVER_ADDRESSES[SupportedChainId.MAINNET]
                    }`}
                    rel="noreferrer"
                  >
                    Useless Royalty Splitter
                  </a>
                </li>
              </ul>
            </Answer>
          </FAQ>
          <FAQ>
            <Question>How is randomness guaranteed for each NFT after mint?</Question>
            <Answer>
              Originally, we were going to spoof the randomness and give ourselves all of the rare ones. Soon after, we
              changed our minds and decided to do it the right way by using{' '}
              <a href={'https://chain.link/chainlink-vrf'} target={'_blank'} rel="noreferrer">
                Chainlink VRF
              </a>{' '}
              to randomly assign the rarity of each NFT in the set.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>How does the Useless Council work? Will they really own the system after the sale?</Question>
            <Answer>
              The Useless Council is a 6 of 11 (that is, 6 signers needed to broadcast a transaction and 11 owners)
              multi-signature wallet. The Useless Council will own the ENS domains that host the website and it will
              receive 50% of the royalties generated on{' '}
              <a href={OPEN_SEA_URL} target={'_blank'} rel="noreferrer">
                OpenSea
              </a>{' '}
              (the other 50% is given to the 1 of 1 diamond NFT owner). The Useless Council also has the unique
              capability of modifying the daily tax rate for changing Useless NFT images and attributes.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>How does the daily tax rate work for changing Useless NFT images and attributes?</Question>
            <Answer>
              After the sale, Useless NFT owners may change the images and attributes of the NFT owners in the tier(s)
              below them. Bronze can change it for plebs, silver can change it for bronze and plebs, and so on.
              Depending on how long this user wants to change the images of those below them, the user can optionally
              pre-pay a tax of 0.1 ETH per day to lock the image & attribute changes. For example, a gold tier user can
              lock the attributes & images of the bronze tier for 10 days by pre-paying 1 ETH to the Useless Council
              upon initiating the image & attribute change. Importantly, the user does not <i>have</i> to pay the tax.
              Rather, they can pay nothing, but that will allow any other Useless NFT holder in the same tier (or
              higher) to immediately overwrite their image and attribute changes.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>How can I change the attributes of the NFT holders of the tier below mine?</Question>
            <Answer>
              Visit the{' '}
              <NavLink id={`change-image-nav-link`} to={'/changeImage'}>
                Change Image
              </NavLink>{' '}
              page to learn more about changing the images and attributes of the NFT holders below your tier.
            </Answer>
          </FAQ>
          <FAQ>
            <Question>How do I get a refund for the NFT I minted?</Question>
            <Answer>You&apos;re kidding, right?</Answer>
          </FAQ>
        </FAQInner>
      </FAQWrapper>
      {/*  Add link for Twitter, OpenSea, GitHub? */}
    </PageWrapper>
  )
}
